/* Keeps the header bag count in step with the Unicorn cart drawer.

   Unicorn replaces the theme's quick-cart, but it never tells the theme when
   the cart changes inside its drawer (quantity steppers, remove, free gift,
   cross-sells). The header badge is only refreshed by the theme's own
   add-to-cart, so after any in-drawer change it showed a stale count until the
   next page load. Unicorn can write the count itself via its
   cartCountSelectors setting, but any selector containing [data-...] makes it
   set an attribute instead of the text — and [data-js-cart-count] is the only
   hook the header has — so the count is synced here from its own event. */
(function () {
  if (window.unicornCartSyncInitialized) return;
  window.unicornCartSyncInitialized = true;

  function countItems(cartData) {
    if (!cartData || !Array.isArray(cartData.items)) return null;
    if (typeof cartData.item_count === 'number') return cartData.item_count;
    return cartData.items.reduce(function (total, item) {
      return total + (Number(item.quantity) || 0);
    }, 0);
  }

  document.addEventListener('unicornCartDataChanged', function (event) {
    const count = countItems(event.detail && event.detail.cartData);
    if (count === null) return;

    document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
      if (el.textContent !== String(count)) el.textContent = count;
    });
  });
})();
